import Vue from 'vue'
import Vuex from 'vuex';
import createdPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        formTitle: '',
        locale: '',
        lastUpdated: '',
        urlPrefix: '',
        country: '',
        writtenLanguage: '',
        keyword: '',
        utm_campaign: '',
        utm_source: '',
        utm_medium: '',
        utm_content: '',
        utm_term: '',
        utm_ts: '',
        utm_ext_ad_id: '',
        utm_ext_adset_id: '',
        utm_ext_campaign_id: '',
        fpv: '',
        referrer: '',
        ipAddress: '',
        ipData: '',
        ipFetched: false,
        quantcastID: '',
        mixpanelID: '',
        segmentID: '',
        cid: '',
        experimentName: '',
        gclid: '',
        _mkto_trk: '',
        msclkid: '',
        phoneValid: '',
        phoneType: '',
        emailValid: '',
        isEU: false,
        functionalOptIn: true,
        analyticsOptIn: true,
        advertisingOptIn: true,
        recaptchaToken: '',
        zap: '',
        thankYou: '',
        backButtonText: '',
        submitted: false,
        referralID: ''
    },
    getters: {
        formFields: state => state.formFields
    },
    mutations: {
        setupFormFields: (state, formFields) => Vue.set(state, 'formFields', formFields),
        updateField: (state, {name, value}) => state.formFields[name] = value,
        addField: (state, {name, value}) => Vue.set(state, name, value),
        formTitle: (state, value) => state.formTitle = value,
        locale: (state, value) => state.locale = value,
        lastUpdated: (state, value) => state.lastUpdated = value,
        urlPrefix: (state, value) => state.urlPrefix = value,
        country: (state, value) => state.country = value,
        writtenLanguage: (state, value) => state.writtenLanguage = value,
        keyword: (state, value) => state.keyword = value,
        utm_campaign: (state, value) => state.utm_campaign = value,
        utm_source: (state, value) => state.utm_source = value,
        utm_medium: (state, value) => state.utm_medium = value,
        utm_content: (state, value) => state.utm_content = value,
        utm_term: (state, value) => state.utm_term = value,
        utm_ts: (state, value) => state.utm_ts = value,
        utm_ext_ad_id: (state, value) => state.utm_ext_ad_id = value,
        utm_ext_adset_id: (state, value) => state.utm_ext_adset_id = value,
        utm_ext_campaign_id: (state, value) => state.utm_ext_campaign_id = value,
        fpv: (state, value) => state.fpv = value,
        referrer: (state, value) => state.referrer = value,
        ipAddress: (state, value) => state.ipAddress = value,
        ipData: (state, value) => state.ipData = value,
        ipFetched: (state, value) => state.ipFetched = value,
        quantcastID: (state, value) => state.quantcastID = value,
        mixpanelID: (state, value) => state.mixpanelID = value,
        segmentID: (state, value) => state.segmentID = value,
        cid: (state, value) => state.cid = value,
        experimentName: (state, value) => state.experimentName = value,
        gclid: (state, value) => state.gclid = value,
        _mkto_trk: (state, value) => state._mkto_trk = value,
        msclkid: (state, value) => state.msclkid = value,
        phoneValid: (state, value) => state.phoneValid = value,
        phoneType: (state, value) => state.phoneType = value,
        emailValid: (state, value) => state.emailValid = value,
        isEU: (state, value) => state.isEU = value,
        functionalOptIn: (state, value) => state.functionalOptIn = value,
        analyticsOptIn: (state, value) => state.analyticsOptIn = value,
        advertisingOptIn: (state, value) => state.advertisingOptIn = value,
        recaptchaToken: (state, value) => state.recaptchaToken = value,
        zap: (state, value) => state.zap = value,
        thankYou: (state, value) => state.thankYou = value,
        backButtonText: (state, value) => state.backButtonText = value,
        submitted: (state, value) => state.submitted = value,
        referralID: (state, value) => state.referralID = value
    },
    plugins: [createdPersistedState({ key: 'PricingForm', storage: window.localStorage })]
});

export default store;
